import React from "react";
import {
  Sparkles,
  Camera,
  Heart,
  MapPin,
  ShoppingBag,
  Calendar,
  Star,
  Smartphone,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Social Lifestyle Apps",
    description:
      "Build social platforms for sharing experiences and connections",
    icon: Heart,
  },
  {
    title: "Beauty & Fashion Tech",
    description: "AR try-on, styling recommendations, and beauty apps",
    icon: Sparkles,
  },
  {
    title: "Event & Experience Apps",
    description: "Discover and book lifestyle experiences and events",
    icon: Calendar,
  },
  {
    title: "Content Creation Tools",
    description: "Photo/video editing and content sharing platforms",
    icon: Camera,
  },
  {
    title: "Local Discovery",
    description:
      "Location-based discovery for restaurants, venues, and activities",
    icon: MapPin,
  },
  {
    title: "Subscription Boxes",
    description: "Curated subscription and membership platforms",
    icon: ShoppingBag,
  },
  {
    title: "Reviews & Recommendations",
    description: "Rating and recommendation systems for lifestyle services",
    icon: Star,
  },
  {
    title: "Mobile-First Experiences",
    description: "Native apps designed for modern lifestyle consumers",
    icon: Smartphone,
  },
];

const STATS = [
  { value: "80+", label: "Lifestyle Apps" },
  { value: "20M+", label: "Users" },
  { value: "4.8★", label: "Avg Rating" },
  { value: "Viral", label: "Growth" },
];

const LifestyleIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="lifestyle"
      industryTitle="Lifestyle"
      industrySubtitle="& Social"
      heroDescription="Creating engaging lifestyle platforms and social apps that connect people with experiences, trends, and communities that enrich their daily lives."
      themeColor="#fb7185"
      themeColorLight="#fda4af"
      themeGradient="linear-gradient(135deg, #9f1239 0%, #e11d48 50%, #fb7185 100%)"
      HeroIcon={Sparkles}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1441986300917-64674bd600d8?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default LifestyleIndustryPage;
